export default __webpack_public_path__ + "images/line-chart-in-circle.60616c1368ecd46cacfd0f1d71267738.png";